import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { Divider, Button, Icon, Checkbox } from 'antd'
import QAApi from 'api/QAApi'
import PageContainer from 'layout/default-sidebar-layout/PageContainer'
import slug from 'constants/slug'
import { autobind } from 'core-decorators'
import createManagerList from 'hoc/manager-list'
import createManagerDelete from 'hoc/manager-delete'
// import createManagerDelete from 'hoc/manager-delete'
import createLanguageHoc, { langPropTypes } from 'hoc/create-lang'
import DynamicTable from 'components/elements/dynamic-table'
import Breadcrumb from 'containers/qa/breadcrumb'
//import { clearScreenDown } from 'readline';

const FloatRight = styled.div`
  text-align: right;
`
const IconButton = styled(Icon)`
  padding-right: 5px;
  color: ${props => (props.color ? props.color : '#3E90F7')};
`

@createManagerList({
  apiList: QAApi.getQA,
  itemPerPage: 10
})
@createManagerDelete({
  apiDelete: QAApi.deleteQA
})
@createLanguageHoc
@autobind
export default class QAList extends React.Component {
  static propTypes = {
    dataSource: PropTypes.array,
    isLoading: PropTypes.bool,
    pagination: PropTypes.object,
    onChangePage: PropTypes.func,
    onChangePageSize: PropTypes.func,
    onDeleteItem: PropTypes.func,
    fetchData: PropTypes.func,
    lang: langPropTypes
  }

  state = {
    isAdvanced: false
  }

  buttonAdd() {
    const { lang: { t } } = this.props
    return (
      <div>
        <Link to={slug.qa.create}>
          <Button type="primary">
            <Icon type="plus" /> {t('addon.create')}
          </Button>
        </Link>
      </div>
    )
  }

  getHead() {
    return [
      { content: '#', width: 5 },
      { content: 'Title' },
      { content: 'Number Order' },
      { content: 'Is Publish' }
    ]
  }

  getRows() {
    return this.props.dataSource.map((row, index) => [
      {
        content: <strong>{index + 1}</strong>
      },
      {
        content: (
          <div>
            <strong>{row.title}</strong>
          </div>
        )
      },
      {
        content: (
          <div>
            <strong>{row.numericalOrder}</strong>
          </div>
        )
      },
      {
        content: (
          <div>
            <Checkbox checked={row.isPublish} />
          </div>
        )
      },
      {
        content: (
          <FloatRight>
            <Link to={slug.qa.editWithKey + '/' + row._id}>
              <IconButton type="edit" />
            </Link>
            <Divider type="vertical" />
            <a
              onClick={() =>
                this.props.onDeleteItem(row._id, this.props.fetchData)
              }
            >
              <IconButton type="delete" color={'red'} />
            </a>
          </FloatRight>
        )
      }
    ])
  }

  render() {
    return (
      <PageContainer right={this.buttonAdd()}>
        <Breadcrumb items={['list']} />
        <DynamicTable
          rows={this.getRows()}
          head={this.getHead()}
          paginationOptions={{
            isSticky: 1
          }}
          onSetPage={this.props.onChangePage}
          pagination={this.props.pagination}
        />
      </PageContainer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/qa/list/index.js